export default "__VITE_ASSET__evsqX0iy__"